var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"panel-yellow"},[_c('i',{staticClass:"fas fa-bell-exclamation icon"}),(_vm.isHtml)?_c('p',{staticClass:"content"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.message)}})]):_c('p',{staticClass:"content"},[_vm._v(" "+_vm._s(_vm.message)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }